import { toast } from "react-toastify";
import defaultErrorHandler from "actions/global/default-error-handler";

import {
  requestGetCurrencies,
  requestGetStatuses,
  requestGetTypes,
  requestRefund,
  requestExport
} from "actions/transaction/requests";

import {
  TRANSACTIONS_LOADING,
  TRANSACTIONS_ERROR,

  TRANSACTIONS_GET_CURRENCIES,
  TRANSACTIONS_GET_STATUSES,
  TRANSACTIONS_GET_TYPES,
  TRANSACTIONS_GET_LIST,
  TRANSACTIONS_GET_FILTERS,
} from "actions/transaction/constants";
import { requestCommonFilters, requestCommonSearch } from "../common/requests";

export const setLoading = status => ({
  type: TRANSACTIONS_LOADING,
  payload: status
});

export const getCurrencies = () => dispatch => {
  dispatch(setLoading(true));
  requestGetCurrencies()
    .then(response => {
      dispatch({
        type: TRANSACTIONS_GET_CURRENCIES,
        payload: response.data.content
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, TRANSACTIONS_ERROR));
    });
};

export const getStatuses = () => dispatch => {
  dispatch(setLoading(true));
  requestGetStatuses()
    .then(response => {
      dispatch({
        type: TRANSACTIONS_GET_STATUSES,
        payload: response.data.content
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, TRANSACTIONS_ERROR));
    });
};

export const getTypes = () => dispatch => {
  dispatch(setLoading(true));
  requestGetTypes()
    .then(response => {
      dispatch({
        type: TRANSACTIONS_GET_TYPES,
        payload: response.data.content
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, TRANSACTIONS_ERROR));
    });
};

export const getFilters = () => dispatch => {
  dispatch(setLoading(true));
  requestCommonFilters("transaction")
    .then((response) => {
      dispatch({
        type: TRANSACTIONS_GET_FILTERS,
        payload: response.data.content
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, TRANSACTIONS_ERROR));
    });
};

export const getList = (page = 0, size = 20, sort = "startDate,desc", filters = []) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch("transaction", page, size, sort, filters)
    .then(response => {
      dispatch({
        type: TRANSACTIONS_GET_LIST,
        payload: response
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, TRANSACTIONS_ERROR));
    });
};

export const refund = (transactionId, callback = false) => dispatch => {
  dispatch(setLoading(true));
  requestRefund(transactionId)
    .then(() => {
      toast("Refund finished successfully", {
        type: toast.TYPE.SUCCESS,
      });
      if (callback) callback();
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, TRANSACTIONS_ERROR));
    });
};

export const exportTransactions = (userId, callback) => dispatch => {
  dispatch(setLoading(true));
  requestExport(userId)
    .then(response => {
      callback(response.data.content);
      dispatch(setLoading(false));
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, TRANSACTIONS_ERROR));
    });
};



// WEBPACK FOOTER //
// ./src/actions/transaction/actions.js